// extracted by mini-css-extract-plugin
export default {"landscapeDocumentsWrapper":"LandscapeDocumentsPage_landscapeDocumentsWrapper__w9v-4"};